// src/api/client.js
const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");

export function getToken() {
    return localStorage.getItem("accessToken") || "";
}

export function setToken(token) {
    if (token) localStorage.setItem("accessToken", token);
    else localStorage.removeItem("accessToken");
}

export function clearAuth() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userEmail");
}

// path는 반드시 "/something" 형태로 들어오게
function buildUrl(path) {
    if (!path) throw new Error("apiFetch: path is required");
    if (path.startsWith("http")) return path;
    if (!path.startsWith("/")) path = "/" + path;
    return API_BASE ? `${API_BASE}${path}` : path;
}

export async function apiFetch(path, options = {}) {
    const url = buildUrl(path);

    const headers = new Headers(options.headers || {});
    headers.set("Accept", "application/json");

    // body가 일반 object면 JSON으로 자동 변환
    let body = options.body;
    const isForm = body instanceof FormData;
    const isBlob = body instanceof Blob;
    const isString = typeof body === "string";

    if (body && !isForm && !isBlob && !isString && typeof body === "object") {
        headers.set("Content-Type", "application/json");
        body = JSON.stringify(body);
    } else if (isString && !headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
    }

    const token = getToken();
    if (token) headers.set("Authorization", `Bearer ${token}`);

    const resp = await fetch(url, {
        ...options,
        headers,
        body,
    });

    // 401이면 강제 로그아웃 이벤트
    if (resp.status === 401) {
        clearAuth();
        window.dispatchEvent(new Event("auth:logout"));
    }

    return resp;
}

function safeJsonParse(text) {
    try {
        return JSON.parse(text);
    } catch {
        return null;
    }
}

export async function apiJson(path, options = {}) {
    const resp = await apiFetch(path, options);
    const text = await resp.text();
    const data = text ? safeJsonParse(text) : null;

    if (!resp.ok) {
        const msg =
            (data && (data.message || data.error)) ||
            (text && text.slice(0, 200)) ||
            `HTTP ${resp.status}`;
        const err = new Error(msg);
        err.status = resp.status;
        err.data = data;
        throw err;
    }
    return data;
}
